{
  "iframeWaitingMessage": "Danke, dass du gewartet hast! Noch ein paar Minuten...",
  "otherOrganizations": "Andere Unternehmen",
  "solutionIframe": "Hauptinhalt",
  "unloadPromptMessage": "Sind Sie sicher?"
}
